import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { fetchCompaniesKPIs } from '@/api/v4/organization.api';
import { appliedCompaniesFiltersState } from '../companies.state';
import { prepareCompanyApiFilters } from '../filters/company-filters-helpers';
import { useAtomValue } from 'jotai';

export const useCompaniesKpi = () => {
  const appliedFilters = useAtomValue(appliedCompaniesFiltersState);

  const getCompaniesKPIs = async () =>
    fetchCompaniesKPIs({
      ...prepareCompanyApiFilters(appliedFilters),
    });

  return useQuery({
    queryKey: [QueryKey.CompaniesKpi, appliedFilters],
    queryFn: getCompaniesKPIs,
    staleTime: getTimeInMs(5, 'minute'),
    gcTime: getTimeInMs(15, 'minute'),
  });
};
